/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Rule_NsfwInputs */

const en_directory_submit_rule_nsfw = /** @type {(inputs: Directory_Submit_Rule_NsfwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No NSFW, adult, or sexually explicit products or content.`)
};

const zh_directory_submit_rule_nsfw = /** @type {(inputs: Directory_Submit_Rule_NsfwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不收录 NSFW、成人或色情产品与内容。`)
};

/**
* | output |
* | --- |
* | "No NSFW, adult, or sexually explicit products or content." |
*
* @param {Directory_Submit_Rule_NsfwInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_rule_nsfw = /** @type {((inputs?: Directory_Submit_Rule_NsfwInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Rule_NsfwInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_rule_nsfw(inputs)
	return zh_directory_submit_rule_nsfw(inputs)
});
export { directory_submit_rule_nsfw as "directory.submit.rule_nsfw" }